module.exports = __webpack_public_path__ + "static/media/214.057389f6.wav";